module.exports = __webpack_public_path__ + "img/右1logo.36b3a0b3.png";